/**
 * Get link info including client name and file status
 * @param {string} linkId - The link ID to fetch info for
 * @returns {Promise<{nombreEmpresa: string, clientId: string, files: Object.<string, {required: boolean, uploaded: boolean}>}>}
 */
export async function getLinkInfo(linkId) {
  try {
    const API_BASE = process.env.REACT_APP_API_URL;
    const response = await fetch(`${API_BASE}/getClienteName`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        linkId
      }),
    });

    if (!response.ok) {
      // Handle rate limiting before trying to parse JSON
      if (response.status === 429) {
        throw new Error('Demasiadas solicitudes');
      }

      const data = await response.json();
      // Handle specific error cases
      switch (response.status) {
        case 400:
          throw new Error(data.error || 'Invalid request - linkId is required');
        case 404:
          throw new Error(data.error || 'Link or client not found');
        case 500:
          throw new Error(data.error || 'Error fetching link info');
        default:
          throw new Error(data.error || 'Error fetching link info');
      }
    }

    const data = await response.json();
    return data.data; // Returns { nombreEmpresa, clientId, files }
  } catch (error) {
    throw error;
  }
}

// Keep old function name for backwards compatibility
export const getClientName = getLinkInfo;
